// Author Lin
// Date 2021-11-26 11:01:11

class MintalMesPrdSmeltingCoolingWater {
        constructor({
                id = null,
                measureTime = '',
                locationId = '',
                locationName = '',
                furnaceId = '',
                furnaceName = '',
                stabilizingPipePressure = '',
                stabilizingPipeLevel = '',
                closedLoopPressure = '',
                closedLoopFlow = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.measureTime = measureTime;
            this.locationId = locationId;
            this.locationName = locationName;
            this.furnaceId = furnaceId;
            this.furnaceName = furnaceName;
            this.stabilizingPipePressure = stabilizingPipePressure;
            this.stabilizingPipeLevel = stabilizingPipeLevel;
            this.closedLoopPressure = closedLoopPressure;
            this.closedLoopFlow = closedLoopFlow;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdSmeltingCoolingWater();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'measureTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.grid.measureTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.grid.furnaceName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'stabilizingPipePressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.grid.stabilizingPipePressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'stabilizingPipeLevel',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.grid.stabilizingPipeLevel',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'closedLoopPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.grid.closedLoopPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'closedLoopFlow',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.grid.closedLoopFlow',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            measureTimeRteFilter : '',
            measureTimeLteFilter : '',
            locationIdFilter : '',
            locationNameFilter : '',
            furnaceIdFilter : '',
            furnaceNameFilter : '',
            stabilizingPipePressureFilter : '',
            stabilizingPipeLevelFilter : '',
            closedLoopPressureFilter : '',
            closedLoopFlowFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'measureTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.filter.measureTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'measureTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.filter.measureTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.filter.furnaceName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'measureTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.entity.measureTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.entity.furnaceName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'stabilizingPipePressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.entity.stabilizingPipePressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'stabilizingPipeLevel',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.entity.stabilizingPipeLevel',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'closedLoopPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.entity.closedLoopPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'closedLoopFlow',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.entity.closedLoopFlow',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingCoolingWater.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdSmeltingCoolingWater, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        